@if (control) {
  <mat-form-field class="acf-full-width" [appearance]="appearance()">
    <mat-label>{{label() | translate}}</mat-label>
    <!-- <mat-label>{{label | translate}}</mat-label> -->
    @if (control) {
      <input (click)="filter()" type="text" aria-label="range" placeholder="{{placeholder() | translate}}" matInput [formControl]="control" [matAutocomplete]="range" [required]="required()!" [disabled]="field_disabled">
    }
    <!-- <ng-container *ngIf="controlName">
    <input (click)="filter()" type="text" aria-label="range" placeholder="{{placeholder | translate}}" matInput [formControlName]="controlName" [matAutocomplete]="range" [required]="required">
  </ng-container> -->
  <mat-autocomplete class="relative" autoActiveFirstOption #range="matAutocomplete" [displayWith]="displayWith">
    @if (this.isLoading()) {
      <mat-option>
        <mat-spinner style="margin: auto;" [diameter]="40" />
      </mat-option>
    }
    @if (!this.isLoading()) {
      @if (this.local_pagination && (filteredOptions.length > this.local_pagination.limit)) {
        <mat-paginator [length]="filteredOptions.length" [pageSize]="this.local_pagination.limit" [hidePageSize]="true" [pageIndex]="this.local_pagination.skip / this.local_pagination.limit" (page)="onPage($event)" />
      }
      @if (this.groupBy()) {
        @for (group of groupedOptions; track trackByItems($index, group)) {
          <mat-optgroup [label]="group.slug">
            @for (option of group.values; track trackByItems($index, option)) {
              <mat-option [value]="value(option)">
                <p class="flex items-center gap-2">
                  <span>{{ getLabel(option) }}</span>
                  @if (secondaryDisplayKey()) {
                    <span class="text-xs text-gray-500">{{ getSecondaryLabel(option) }} </span>
                  }
                </p>
              </mat-option>
            }
          </mat-optgroup>
        }
      } @else {
        @for (option of paginatedOptions; track trackByItems($index, option)) {
          <mat-option [value]="value(option)">
            <p class="flex items-center gap-2">
              <span>{{ getLabel(option) }}</span>
              @if (secondaryDisplayKey()) {
                <span class="text-xs text-gray-500">{{ getSecondaryLabel(option) }} </span>
              }
            </p>
          </mat-option>
        }
      }
    }
  </mat-autocomplete>
  <mat-error> {{error() | translate}} </mat-error>
</mat-form-field>
}